export default __webpack_public_path__ + "static/media/completed-task.f784611d.png";